import React from 'react';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActions,
  Button,
  Box,
} from '@mui/material';

const services = [
  {
    title: 'Birth Certificate',
    description: 'Apply for birth certificates and related documentation.',
    action: 'Apply Now',
  },
  {
    title: 'Death Certificate',
    description: 'Process death certificate applications and verifications.',
    action: 'Apply Now',
  },
  {
    title: 'Property Tax',
    description: 'Pay and manage your property tax payments online.',
    action: 'Pay Now',
  },
  {
    title: 'Water Connection',
    description: 'Apply for new water connections or report issues.',
    action: 'Apply Now',
  },
  {
    title: 'Building Permission',
    description: 'Submit building plans and get construction permits.',
    action: 'Apply Now',
  },
  {
    title: 'Complaints',
    description: 'Register complaints and track their resolution status.',
    action: 'Register',
  },
  {
    title: 'Business License',
    description: 'Apply for various types of business licenses.',
    action: 'Apply Now',
  },
  {
    title: 'Marriage Registration',
    description: 'Register marriages and obtain certificates.',
    action: 'Register',
  },
  {
    title: 'Waste Management',
    description: 'Schedule waste collection and recycling services.',
    action: 'Schedule',
  },
];

const Services = () => {
  return (
    <Container sx={{ py: 8 }}>
      <Typography variant="h3" component="h1" gutterBottom align="center">
        Our Services
      </Typography>
      <Typography variant="body1" paragraph align="center">
        Access various government services and documentation processes online
      </Typography>

      <Box sx={{ mt: 4 }}>
        <Grid container spacing={4}>
          {services.map((service, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card>
                <CardContent>
                  <Typography variant="h5" component="h2" gutterBottom>
                    {service.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {service.description}
                  </Typography>
                </CardContent>
                <CardActions>
                  <Button size="small" color="primary">
                    {service.action}
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
};

export default Services;
